import React from 'react'
import { Icon, IconType } from '@pandiafi/design-system'
import { Chip } from '@pandiafi/components'

import { ComingSoonBadge } from 'components/ComingSoonBadge/ComingSoonBadge'

export interface LinkLabelProps {
  label: string
  icon?: string
  hint?: string
  count?: number
  countLabel?: string
}

export const LinkLabel: React.FC<LinkLabelProps> = ({
  label,
  icon,
  hint,
  count,
  countLabel,
}) => {
  const showCount = count !== undefined && count > 0

  return (
    <>
      {hint && (
        <div className="absolute -top-2.5 right-0 opacity-100 z-40">
          <ComingSoonBadge label={hint} />
        </div>
      )}

      {showCount && (
        <Chip
          count={count}
          size="m"
          className="absolute -top-2.5 -right-2.5 z-40"
          HTMLProps={{ 'aria-hidden': true }}
        />
      )}

      <div data-content="main">
        {icon && (
          <div className="mb-3 flex justify-center">
            <div className="size-14 rounded-full p-0.5 bg-common-gray-3 flex items-center justify-center">
              <Icon
                icon={icon as IconType}
                size="2x"
                className="text-brand-6"
              />
            </div>
          </div>
        )}

        <span className="font-normal text-sm text-center block text-brand-6">
          {label}
        </span>

        {showCount && countLabel && (
          <span className="sr-only">{countLabel}</span>
        )}
      </div>
    </>
  )
}
